export let token;
export let session;
export const setToken = (_token) => {
  window.token = _token;
};
export const setSession = (_session) => {
  window.session = _session;
};



// WEBPACK FOOTER //
// ./src/services/session_token.js